import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface EditionPreset {
  id: string;
  name: string;
  editionValues: string[];
  createdAt: number;
}

interface EditionPresetsState {
  presets: EditionPreset[];
}

interface EditionPresetsActions {
  addPreset: (name: string, editionValues: string[]) => void;
  removePreset: (id: string) => void;
  renamePreset: (id: string, name: string) => void;
}

export const useEditionPresetsStore = create<
  EditionPresetsState & EditionPresetsActions
>()(
  persist(
    set => ({
      presets: [],

      addPreset: (name, editionValues) =>
        set(state => ({
          presets: [
            ...state.presets,
            {
              id: crypto.randomUUID(),
              name,
              editionValues,
              createdAt: Date.now(),
            },
          ],
        })),

      removePreset: id =>
        set(state => ({
          presets: state.presets.filter(p => p.id !== id),
        })),

      renamePreset: (id, name) =>
        set(state => ({
          presets: state.presets.map(p =>
            p.id === id ? { ...p, name } : p
          ),
        })),
    }),
    {
      name: 'edition-presets',
    }
  )
);
